import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { ChoosePlanProps } from './types';
import { SubsciptionCard } from './SubsciptionCard';

export const ChoosePlan = ({
  defaultPriceId,
  onChange,
  prices
}: ChoosePlanProps) => {
  const [selectedId, setSelectedId] = useState(defaultPriceId);

  useEffect(() => {
    setSelectedId(defaultPriceId);
  }, [defaultPriceId]);

  const priceOptions = prices.sort((a, _b) =>
    a.recurring.interval === 'year' ? -1 : 1
  );

  return (
    <Box
      sx={{
        margin: 'auto',
        marginTop: '5px',
        paddingTop: '25px'
      }}
    >
      <Typography
        variant="h5"
        fontWeight="700"
        sx={{ paddingLeft: 6, paddingRight: 6 }}
      >
        Select Subscription Option
      </Typography>
      {priceOptions ? (
        <Grid container direction="column">
          {/* @ts-ignore */}
          {priceOptions.map(({ id, recurring, unit_amount: unitAmount }) => (
            <Grid item sx={{ padding: 6 }} key={`subscription-card-${id}`}>
              <SubsciptionCard
                onChange={() => {
                  setSelectedId(id);
                  onChange(id);
                }}
                selected={id === selectedId}
                subscriptionType={recurring.interval}
                price={unitAmount}
              />
            </Grid>
          ))}
        </Grid>
      ) : null}
    </Box>
  );
};
